<div class="outer-wrapper s-{{size}} a-{{appearance}}" (click)="onClick($event)" [class.disabled]="disabled">
	<div class="inner-wrapper">
		<ng-content>
		</ng-content>
	</div>
</div>
